// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://miygybeltetsajkjsrwy.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1peWd5YmVsdGV0c2Fqa2pzcnd5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDgxMjAwNTQsImV4cCI6MjA2MzY5NjA1NH0.FM9A1y5eklgE6vofImQCqyp4NSh4iNiM1cJre3SJ20k";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);